import { ValidationMessage } from './editVideo.helpers';
import { Alert } from '@mui/material';
import _ from 'lodash';
import { colors } from '@client/new/components/colors';

type EditVideoStatusProps = {
  validationMessage: ValidationMessage;
};

export const EditVideoStatus = ({
  validationMessage,
}: EditVideoStatusProps) => {
  if (_.isEmpty(validationMessage)) {
    return null;
  }

  const statusBarMessage = validationMessage?.text || '';
  const severity = validationMessage?.type || 'info';
  const background =
    validationMessage?.type === 'error'
      ? colors.errorAlertBg
      : validationMessage?.type === 'warning'
      ? colors.warnAlertBg
      : colors.infoAlertBg;
  return (
    <Alert severity={severity} sx={{ background, marginBottom: '16px' }}>
      {statusBarMessage}
    </Alert>
  );
};
